import React from 'react';
import classNames from 'classnames';

import './index.css';

const HomeImage = ({ src, className, alt, href }) => {
    const innerImage = (
        <img 
            src={`${process.env.PUBLIC_URL}/images/${src}`} 
            className='home-image__image'
            width='400px'
            alt={alt || "decorative"}
        />
    );

    return href ? (
        <a 
            className={classNames("home-image", "home-image__link", className)}
            href={href}
        >
            {innerImage}
        </a>
    ) : (
        <div className={classNames("home-image", className)}>
            {innerImage}
        </div>
    )
}

export default HomeImage;



// WEBPACK FOOTER //
// ./src/components/HomeImage/index.js